var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarLiveChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4286 12.5693H13V6.49789C13 3.97825 11.1375 1.8961 8.71429 1.54968V0.855033C8.71429 0.46039 8.39464 0.140747 8 0.140747C7.60536 0.140747 7.28571 0.46039 7.28571 0.855033V1.54968C4.8625 1.8961 3 3.97825 3 6.49789V12.5693H2.57143C2.25536 12.5693 2 12.8247 2 13.1407V13.7122C2 13.7907 2.06429 13.855 2.14286 13.855H6C6 14.9586 6.89643 15.855 8 15.855C9.10357 15.855 10 14.9586 10 13.855H13.8571C13.9357 13.855 14 13.7907 14 13.7122V13.1407C14 12.8247 13.7446 12.5693 13.4286 12.5693ZM8 14.7122C7.52679 14.7122 7.14286 14.3282 7.14286 13.855H8.85714C8.85714 14.3282 8.47321 14.7122 8 14.7122ZM4.28571 12.5693V6.49789C4.28571 5.50503 4.67143 4.57289 5.37321 3.8711C6.075 3.16932 7.00714 2.7836 8 2.7836C8.99286 2.7836 9.925 3.16932 10.6268 3.8711C11.3286 4.57289 11.7143 5.50503 11.7143 6.49789V12.5693H4.28571Z",
    fill: "black",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLiveChat);
export default __webpack_public_path__ + "static/media/sidebar-live-chat.8f84185aeb3ae8a19151ae4593f92811.svg";
export { ForwardRef as ReactComponent };